<template>
  <!-- Menu item cannot get FunctionalComponent as value, that's why it screams here, and that's why custom #item is written here. -->
  <Menu ref="menu" :id="id" :model="menuModel" :popup="true">
    <template #submenuheader="{ item }">
      <span :class="props.submenuLabelClass">{{ item.label }}</span>
    </template>
    <template #item="{ item }">
      <button
        class="p-menu-item-link cursor-pointer"
        :disabled="
          typeof item.disabled === 'function' ? item.disabled() : item.disabled
        "
      >
        <component :is="item.icon" />
        <div class="flex flex-col">
          <span>{{ item.label }}</span>
          <span v-if="item.description" class="text-left text-sm text-gray-500">
            {{ item.description }}
          </span>
        </div>
      </button>
    </template>
  </Menu>
  <slot :toggle="menuRef?.toggle" :id="id" />
</template>

<script setup lang="ts">
import {
  computed,
  FunctionalComponent,
  SVGAttributes,
  useId,
  useTemplateRef,
} from 'vue'
import type { MenuItem } from 'primevue/menuitem'

type DropdownItem = Omit<MenuItem, 'icon' | 'items'> & {
  icon?: FunctionalComponent<SVGAttributes, {}, any, {}>
  items?: DropdownItem[]
  description?: string
}

const props = defineProps<{
  menuItems: DropdownItem[]
  submenuLabelClass?: string
}>()

const menuModel = computed(() => props.menuItems as unknown as MenuItem[])
const menuRef = useTemplateRef('menu')

const id = useId()
</script>
